import styled from 'styled-components'

export const VoidIcon = styled.div`
    align-self: flex-end;
    margin-left: 20px;
    margin-right: 20px;
`